import ElectricDual_one from "../../../assets/images/Dualcab18.jpg";
import ElectricDual_two from "../../../assets/images/ElectricDual_One(2).jpg";
import ElectricDual_three from "../../../assets/images/ElectricDual_One(3).jpg";
import ElectricDual_Four from "../../../assets/images/ElectricDual_One(4).jpg";
import ElectricDual_Five from "../../../assets/images/ElectricDual_One(5).jpg";
import ElectricDual_Six from "../../../assets/images/ElectricDual_One(6).jpg";
import ElectricDual_Seven from "../../../assets/images/Dual cab 1.jpg";

import { useState } from "react";

const images = [
  ElectricDual_Seven,
  ElectricDual_three,
  ElectricDual_Four,
  ElectricDual_Five,
  ElectricDual_Six,
];

const NZElectricDualModels = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  // Tooltip
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);

  const openSlider = (i) => {
    setIndex(i);
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeSlider = () => {
    setOpen(false);
    document.body.style.overflow = "auto";
  };

  const prevImg = () => setIndex((i) => (i === 0 ? images.length - 1 : i - 1));

  const nextImg = () => setIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <>
      <div className="bg-white pt-[20px] pb-[45px]">
        <div className="custom-container px-[20px] sm:px-[30px] text-start mx-auto">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 justify-items-center">
              {/* Image 1 */}
              {/* <div className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white">
              <img
                src={ElectricDual_one}
                alt="Electric Dual 1"
                className="w-[98%] h-[98%] object-contain object-center scale-[1.3] transition-transform duration-300 ml-[30px]"
              />
            </div> */}

              {/* Image 2 */}
              {/* <div className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white">
              <img
                src={ElectricDual_two}
                alt="Electric Dual 2"
                className="w-[98%] h-[98%] object-contain scale-[1.3] transition-transform duration-300"
              />
            </div> */}
              {/* ---- IMAGE 1 ---- */}
              <div
                onClick={() => openSlider(0)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={ElectricDual_Seven}
                  alt="eTuatara 6 seat electric double cab dual motor UTV side view"
                  className="w-[74%] h-[98%] object-contain scale-[1.3]"
                />
              </div>

              {/* ---- IMAGE 2 ---- */}
              <div
                onClick={() => openSlider(1)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={ElectricDual_three}
                  alt="Front view of eTuatara 6 seat electric double cab dual motor utility vehicle"
                  className="w-[98%] h-[98%] object-contain scale-[1.6] object-[21px_12px]"
                />
              </div>

              {/* ---- IMAGE 3 ---- */}
              <div
                onClick={() => openSlider(2)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={ElectricDual_Four}
                  alt="Front three quarter view of eTuatara electric double cab dual motor UTV"
                  className="w-[98%] h-[98%] object-contain scale-[1.1]"
                />
              </div>

              {/* ---- IMAGE 4 ---- */}
              <div
                onClick={() => openSlider(3)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={ElectricDual_Five}
                  alt="Rear three quarter view of eTuatara 6 seat electric double cab UTV"
                  className="w-[98%] h-[98%] object-contain scale-[1.1]"
                />
              </div>

              {/* ---- IMAGE 5 ---- */}
              <div
                onClick={() => openSlider(4)}
                onMouseMove={(e) => {
                  setTooltipPos({ x: e.clientX, y: e.clientY });
                  setShowTooltip(true);
                }}
                onMouseLeave={() => setShowTooltip(false)}
                className="border border-black w-full aspect-square flex items-center justify-center overflow-hidden bg-white cursor-pointer"
              >
                <img
                  src={ElectricDual_Six}
                  alt="eTuatara electric double cab UTV with doors open showing cabin space"
                  className="w-[98%] h-[98%] object-contain scale-[1.1]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------------- FULL SCREEN MANUAL SLIDER ---------------- */}
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[99999]"
          onClick={closeSlider}
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}>
            {/* CLOSE BUTTON */}
            <button
              onClick={closeSlider}
              className="absolute top-[-50px] right-0 text-white text-4xl md:text-5xl lg:text-6xl"
            >
              ×
            </button>

            {/* LEFT ARROW */}
            <button
              onClick={prevImg}
              className="absolute left-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl cursor-pointer"
            >
              ‹
            </button>

            {/* MAIN IMAGE */}
            <img
              src={images[index]}
              className="max-h-[80vh] max-w-[90vw] object-contain bg-white rounded-lg shadow-xl"
            />

            {/* RIGHT ARROW */}
            <button
              onClick={nextImg}
              className="absolute right-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl cursor-pointer"
            >
              ›
            </button>
          </div>
        </div>
      )}

      {/* TOOLTIP */}
      {showTooltip && (
        <div
          className="fixed z-[99999] bg-black text-white text-[13px] px-3 py-1 rounded-md shadow-lg pointer-events-none"
          style={{ top: tooltipPos.y + 15, left: tooltipPos.x + 15 }}
        >
          Click here to expand
        </div>
      )}
    </>
  );
};

export default NZElectricDualModels;
